import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import creditBracketListAction from './creditBracketList.action.json' with { type: 'json' }
import { creditBracketObject } from '../creditBracketObject'

export const creditBracketExpression = expression(creditBracketObject.shape)

const creditBracketListDefinition = defineAction({
  ...creditBracketListAction,

  input: z.object({
    filter: creditBracketExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      initialValue: 'Valor inicial',
      finalValue: 'Valor final',
      percentage: 'Percentual',
      fixedValue: 'Valor fixo',
      maximumValue: 'Limite máximo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(creditBracketObject),
    count: z.number(),
  }),
})

export default creditBracketListDefinition

